/* DASKI top - トップ専用 JS */

/* ファーストビュースライダー <daski-kv> */
if (!customElements.get('daski-kv')) {
  customElements.define(
    'daski-kv',
    class DaskiKv extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.daski-kv__slide'));
        this.nums = Array.from(this.querySelectorAll('.daski-kv__num'));
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay = this.dataset.autoplay !== 'false';

        // モーション抑制時は自動再生しない
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.autoplay = false;
        }

        this.nums.forEach((btn, i) => {
          btn.addEventListener('click', () => {
            this.goTo(i);
            this.restart();
          });
        });

        this.goTo(0);
        this.start();

        // ホバー中は一時停止
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(i) {
        if (!this.slides.length) return;
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
        this.nums.forEach((b, n) => {
          const active = n === this.index;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      next() {
        this.goTo(this.index + 1);
      }

      start() {
        if (!this.autoplay || this.slides.length <= 1) return;
        this.stop();
        this.timer = setInterval(() => this.next(), this.speed);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        this.start();
      }
    }
  );
}

/* 自動フェード切替（ナビなし）<daski-fade> */
if (!customElements.get('daski-fade')) {
  customElements.define(
    'daski-fade',
    class DaskiFade extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.children);
        this.i = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 4000;
        this.items.forEach((el, n) => el.classList.toggle('is-active', n === 0));

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.items.length <= 1 || reduce) return;

        this.timer = setInterval(() => this.next(), this.speed);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      next() {
        this.items[this.i].classList.remove('is-active');
        this.i = (this.i + 1) % this.items.length;
        this.items[this.i].classList.add('is-active');
      }
    }
  );
}
